import { APIClient } from "../../../../api/api_helper";
import { CurrentUser, GetUserData } from "../../../../common/service/CommonService";
import { Workflow_API } from "../../../../api/url_helper";

/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * WORKFLOW API
 * ------------------------------------------------------------------ */

export const WorkflowAPI = {
  insertData: (workflow: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      workflow: workflow,
      createdby: user.userid,
    };
    return api.create(Workflow_API.Workflow_API + "Insert", payload);
  },

  getSelectAllData: (
    searchText?: string | null,
    currentPage?: number | null,
    pageSize?: number | null,
  ) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: currentPage === 0 ? 1 : currentPage,
      pagesize: pageSize,
    };
    return api.create(Workflow_API.Workflow_API + "SelectAll", payload);
  },

  getSelectData: (id?: number | null) => {
    const payload = {
      workflowid: id,
    };
    return api.create(Workflow_API.Workflow_API + "Select", payload);
  },

  deleteData: (payload_data: { id: number | null; updatereason: string }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      workflowid: payload_data.id,
      updatereason: payload_data.updatereason,
      updatedby: user?.userid,
    };
    return api.create(Workflow_API.Workflow_API + "Delete", payload);
  },

  // DROPDOWN METHOD
  getDropdownData: () => {
    const payload = {
      status: "A",
    };
    return api.create(Workflow_API.Workflow_API + "Dropdown", payload);
  },

  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      workflowid: payload_data.workflowid,
      name: payload_data.name,
      attachedmodule: payload_data.attachedmodule,
      updatedby: user.userid,
      updatereason: payload_data.updatereason,
    };
    return api.create(Workflow_API.Workflow_API + "Update", payload);
  },

  getStageSelectData: (payload_data: any) => {
    const payload = {
      studyid: payload_data.studyid,
      workflowid: payload_data.workflowid,
    };
    return api.create(Workflow_API.Workflow_API + "StageSelect", payload);
  },

  switchStageData: (payload: any) => {
    return api.create(Workflow_API.Workflow_API + "StageSwitch", payload);
  },

  getQuerySelectAllData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      studyid: payload_data.studyid,
      userid: user.userid,
      pagenumber: payload_data.pagenumber || 1,
      pagesize: payload_data.pagesize || 10,
    };
    return api.create(Workflow_API.Workflow_API + "QuerySelectAll", payload);
  },

  raiseQueryData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      studyid: payload_data.studyid,
      currentstageid: payload_data.currentstageid,
      querymessage: payload_data.querymessage,
      querystatus: "OPENED",
      createdby: user.userid,
    };
    return api.create(Workflow_API.Workflow_API + "RaiseQuery", payload);
  },

  updateQueryData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      studyid: payload_data.studyid,
      querymasterid: payload_data.querymasterid,
      currentstageid: payload_data.currentstageid,
      querymessage: payload_data.querymessage,
      querystatus: payload_data.querystatus,
      createdby: user.userid,
      updatereason: payload_data.updatereason || "Query Respond ",
    };
    return api.create(Workflow_API.Workflow_API + "UpdateQuery", payload);
  },
};
